module.exports = __webpack_public_path__ + "static/media/business.ab10b2be.svg";